/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NoticeLinkedListPage = lazyLoad(
  () => import('./index'),
  module => module.NoticeLinkedListPage
);
